import getScrollContainer from './getScrollContainer';
import DockingViewState from '../store/schema/DockingViewState';
import { EditorViewState } from 'owa-editor';

export default function tryScrollIntoView(
    editorViewState: EditorViewState,
    dockingViewState: DockingViewState
) {
    const scrollContainer = getScrollContainer(editorViewState);
    const initialVisiblePart = dockingViewState?.initialVisiblePart;

    if (scrollContainer && initialVisiblePart) {
        const viewport = scrollContainer.getBoundingClientRect();
        const inlineComposeRect = initialVisiblePart.getBoundingClientRect();

        if (inlineComposeRect.bottom > viewport.bottom) {
            scrollContainer.scrollTop += inlineComposeRect.bottom - viewport.bottom;
        }
        if (inlineComposeRect.top < viewport.top) {
            scrollContainer.scrollTop += inlineComposeRect.top - viewport.top;
        }
    }
}
